import React, { useState, useEffect, useMemo, useCallback } from "react";
import { connect, ConnectedProps } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import { IStore } from "redux/store";
import toolActions from "redux/app/tool/actions";
import { Dispatch } from "redux";
import classNames from "classnames";
import { IJobData } from "redux/app/tool/@types";
import InfiniteProgress from "components/_common/InfiniteProgress";
import { commonUtils } from "redux/_common";
import toolSelectors from "redux/app/tool/selectors";
import Select from "react-select";
import clsx from "clsx";
import DateRangePickerVerbose from "components/_common/DateRangePickerVerbose";
import { Range, RangeKeyDict } from "react-date-range";
import { defineds } from "redux/_common/utils";
import { logsPdfDefaultStaticRanges } from "redux/app/insight/utils";
import { IOption } from "redux/app/feedback/@types";
import ModalPortal from "components/app/_common/ModalPortal";
import {
	clearIndicatorStyles,
	controlStyles,
	dropdownIndicatorStyles,
	menuStyles,
	optionStyles,
	placeholderStyles,
} from "redux/app/feedback/utils";
import Pagination from "components/_common/NumberedPagination";
import { startOfYear } from "date-fns";

// Define a structure for vessels by tenant
interface IVessel {
	id: string;
	vesselName: string;
	[key: string]: any;
}

type OwnProps = {
	onBack: () => void;
	onRefreshRef?: React.MutableRefObject<(() => void) | null>;
};
type JobsHistoryProps = PropsFromRedux & OwnProps;

function JobsHistory(props: JobsHistoryProps) {
	const [isLoading, setIsLoading] = useState(false);
	const [expandedRows, setExpandedRows] = useState<string[]>([]);
	const [sortBy, setSortBy] = useState<string>("timestamp");
	const [sortDirection, setSortDirection] = useState<"asc" | "desc">("desc");
	const [filters, setFilters] = useState<{
		status?: "all" | "success" | "failure";
		tenant?: string;
		vesselName?: string;
		logType?: string;
	}>({
		status: "all",
	});

	// New filter fields state
	const [selectedTenantOption, setSelectedTenantOption] =
		useState<IOption | null>(null);
	const [selectedVesselOption, setSelectedVesselOption] =
		useState<IOption | null>(null);
	const [selectedLogOption, setSelectedLogOption] = useState<IOption | null>(
		null
	);
	const [dateRange, setDateRange] = useState<Range[]>([
		{
			startDate: startOfYear(new Date()),
			endDate: defineds.endOfToday,
			key: "selection",
		},
	]);
	const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

	// Removed vessel state management - no longer needed

	const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
	const [showBulkRegenerateModal, setShowBulkRegenerateModal] =
		useState<boolean>(false);
	// Change this to track multiple regenerating jobs
	const [regeneratingJobs, setRegeneratingJobs] = useState<Set<string>>(
		new Set()
	);

	// Pagination state
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(10);

	// Convert API pagination to NumberedPagination format
	const getPaginationForView = () => {
		const pagination = props.jobsHistoryPagination;
		return {
			currentPage: Math.floor(pagination.offset / pagination.limit) + 1,
			itemsPerPage: pagination.limit,
			totalItems: pagination.total,
			itemIds: props.jobsHistory.jobs.map((job: IJobData) => job.raw), // Use job raw as unique ID
		};
	};

	// Handle page change
	const handlePageChange = (pageNumber: number, itemsPerPage: number) => {
		setCurrentPage(pageNumber);
		loadJobsHistory(pageNumber);
	};

	// Sync currentPage state with pagination data
	useEffect(() => {
		const pagination = props.jobsHistoryPagination;
		const calculatedPage = Math.floor(pagination.offset / pagination.limit) + 1;
		if (calculatedPage !== currentPage) {
			setCurrentPage(calculatedPage);
		}
	}, [props.jobsHistoryPagination, currentPage]);

	// const handleBulkRegenerate = () => {
	// 	// Show confirmation modal instead of directly executing
	// 	setShowBulkRegenerateModal(true);
	// };

	// const handleConfirmBulkRegenerate = async () => {
	// 	setShowBulkRegenerateModal(false);
	// 	setIsRefreshing(true);

	// 	try {
	// 		const startDate = commonUtils.correctToLocalDateISO(
	// 			dateRange[0].startDate as Date
	// 		);
	// 		const endDate = commonUtils.correctToLocalDateISO(
	// 			dateRange[0].endDate as Date,
	// 			true
	// 		);

	// 		const tenantName = selectedTenantOption
	// 			? props.tenants.byIds[selectedTenantOption.value]?.name || ""
	// 			: "";
	// 		const vesselId = selectedVesselOption?.value || "";
	// 		const code = selectedLogOption?.value || "";

	// 		// Build the URL with query parameters
	// 		const url = new URL(
	// 			`${commonUtils.getLogsPdfBaseUrl()}/refetch_processed_pdfs`
	// 		);
	// 		if (tenantName) url.searchParams.append("tenantName", tenantName);
	// 		if (vesselId) url.searchParams.append("vesselId", vesselId);
	// 		if (code) url.searchParams.append("code", code);
	// 		if (startDate) url.searchParams.append("startDate", startDate);
	// 		if (endDate) url.searchParams.append("endDate", endDate);
	// 		if (vesselId)
	// 			url.searchParams.append(
	// 				"vesselName",
	// 				selectedVesselOption?.label || ""
	// 			);
	// 		// @ts-ignore
	// 		url.searchParams.append("userId", props.user?.userId || "");
	// 		url.searchParams.append("tenantId", selectedTenantOption?.value || "");
	// 		// Make the API call
	// 		const response = await fetch(url.toString(), {
	// 			method: "GET",
	// 			headers: {
	// 				"Content-Type": "application/json",
	// 			},
	// 		});

	// 		if (response.ok) {
	// 			toast.success("Bulk regeneration request submitted successfully");
	// 			loadJobsHistory(currentPage); // Refresh jobs list
	// 		} else {
	// 			toast.error("Failed to submit bulk regeneration request");
	// 		}
	// 	} catch (error) {
	// 		console.error("Error submitting bulk regeneration request:", error);
	// 		toast.error("Error submitting bulk regeneration request");
	// 	} finally {
	// 		setIsRefreshing(false);
	// 	}
	// };	

	const handleCancelBulkRegenerate = () => {
		setShowBulkRegenerateModal(false);
	};

	// Function to calculate the count of PDFs that would be regenerated
	// const getRegenerateCount = () => {
	// 	// Use the total count from API stats (backend filtered)
	// 	return getStats().total;
	// };

	// Render the bulk regenerate confirmation modal
	// const renderBulkRegenerateModal = () => {
	// 	const count = getRegenerateCount();

	// 	return (
	// 		<ModalPortal
	// 			isActive={showBulkRegenerateModal}
	// 			onClose={handleCancelBulkRegenerate}
	// 			width="400px"
	// 		>
	// 			<div className="bg-white rounded-lg shadow-xl p-6">
	// 				<div className="flex items-center mb-4">
	// 					<div className="flex-shrink-0">
	// 						<svg
	// 							className="w-6 h-6 text-amber-600"
	// 							fill="none"
	// 							stroke="currentColor"
	// 							viewBox="0 0 24 24"
	// 						>
	// 							<path
	// 								strokeLinecap="round"
	// 								strokeLinejoin="round"
	// 								strokeWidth={2}
	// 								d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
	// 							/>
	// 						</svg>
	// 					</div>
	// 					<div className="ml-3">
	// 						<h3 className="text-lg font-medium text-gray-900">
	// 							Confirm Bulk Regeneration
	// 						</h3>
	// 					</div>
	// 				</div>
	// 				<div className="mb-6">
	// 					<p className="text-sm text-gray-600">
	// 						You are about to regenerate <strong>{count}</strong> PDF
	// 						{count !== 1 ? "s" : ""} based on your current filter criteria.
	// 					</p>
	// 					<p className="text-sm text-gray-600 mt-2">
	// 						This action will submit regeneration requests for all matching
	// 						jobs. Do you want to continue?
	// 					</p>
	// 				</div>
	// 				<div className="flex justify-end gap-3">
	// 					<button
	// 						onClick={handleCancelBulkRegenerate}
	// 						className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
	// 					>
	// 						No, Cancel
	// 					</button>
	// 					<button
	// 						onClick={handleConfirmBulkRegenerate}
	// 						disabled={isRefreshing}
	// 						className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 transition-colors disabled:bg-blue-400"
	// 					>
	// 						{isRefreshing ? "Processing..." : "Yes, Regenerate"}
	// 					</button>
	// 				</div>
	// 			</div>
	// 		</ModalPortal>
	// 	);
	// };

	const handleClearFilters = () => {
		setSelectedTenantOption(null);
		setSelectedVesselOption(null);
		setSelectedLogOption(null);
		setDateRange([
			{
				startDate: defineds.past30days,
				endDate: defineds.endOfToday,
				key: "selection",
			},
		]);
		setFilters({ status: "all" });
	};

	// Removed unique tenants logic - no longer needed for vessel mapping

	// Create tenant options from tenants store (like LogsPdfManager)
	const tenantOptions = useMemo(() => {
		if (!props.tenants || !props.tenants.ids.length) return [];
		return props.tenants.ids.map((id: string) => ({
			value: id,
			label: props.tenants.byIds[id].name,
		}));
	}, [props.tenants]);

	// Create vessel options from vessels store
	const vesselOptions = useMemo(() => {
		if (!props.vessels || !props.vessels.ids.length) return [];
		return props.vessels.ids.map((id: string) => ({
			value: props.vessels.byIds[id].id,
			label: props.vessels.byIds[id].vesselName,
		}));
	}, [props.vessels]);

	// Static log type options (like LogsPdfManager)
	const logTypeOptions = useMemo(
		() => [
			{ label: "Engine Log", value: "engineLogConfig" },
			{ label: "Deck Log", value: "deckLogConfig" },
			{ label: "Port Log", value: "portLogConfig" },
			{ label: "GMDSS Radio Log", value: "gmdssRadioConfig" },
			{ label: "Radar Log", value: "radarLogConfig" },
			{ label: "Compass Log", value: "compassLogConfig" },
			{ label: "Bridge Order Book", value: "bridgeOrderConfig" },
			{ label: "Engine Order Book", value: "engineOrderConfig" },
			{ label: "Medical Log", value: "medicalLogConfig" },
		],
		[]
	);

	useEffect(() => {
		const loadData = async () => {
			await loadJobsHistory(1);
		};
		loadData();
		props.loadTenants();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		// Load vessels when tenant changes
		if (selectedTenantOption?.value) {
			props.loadVessels(selectedTenantOption.value);
		}
	}, [selectedTenantOption]); // eslint-disable-line react-hooks/exhaustive-deps

	// Reload data when filters change
	useEffect(() => {
		// Reset to first page when filters change
		setCurrentPage(1);
		loadJobsHistory(1);
	}, [
		dateRange,
		selectedTenantOption,
		selectedVesselOption,
		selectedLogOption,
		filters.status,
	]); // eslint-disable-line react-hooks/exhaustive-deps

	// Removed loadVesselsForTenant function - no longer needed

	// Build filters object from current state
	const buildFilters = () => {
		const tenantId = selectedTenantOption?.value || "";
		const vesselId = selectedVesselOption?.value || "";
		const code = selectedLogOption?.value || "";
		const status = filters.status || "all";

		return {
			startDate: commonUtils.correctToLocalDateISO(
				dateRange[0].startDate as Date
			),
			endDate: commonUtils.correctToLocalDateISO(
				dateRange[0].endDate as Date,
				true
			),
			tenantId,
			vesselId,
			code,
			status,
		};
	};

	const loadJobsHistory = useCallback(
		async (page: number = currentPage) => {
			try {
				setIsLoading(true);
				const filterParams = buildFilters();
				await props.loadJobsHistory(page, itemsPerPage, filterParams);
			} catch (error) {
				toast.error("Failed to load jobs history");
			} finally {
				setIsLoading(false);
			}
		},
		[
			currentPage,
			dateRange,
			selectedTenantOption,
			selectedVesselOption,
			selectedLogOption,
			filters.status,
			props.loadJobsHistory,
			itemsPerPage,
		]
	); // eslint-disable-line react-hooks/exhaustive-deps

	// Expose refresh method to parent component
	React.useEffect(() => {
		if (props.onRefreshRef) {
			props.onRefreshRef.current = () => {
				loadJobsHistory(currentPage);
			};
		}
	}, [loadJobsHistory, currentPage, props.onRefreshRef]);

	const handleRegenerate = async (job: IJobData) => {
		// Add this job to regenerating set
		setRegeneratingJobs((prev) => new Set(prev).add(job.raw));

		try {
			const selectedDate = job.date;
			const code = job.code;
			const tenantName = job.tenantName;
			const tenantId = job.tenant_id;
			const vesselId = job.vesselId;
			const isIDL = job.internationalDateLine;
			const vesselName = job.vesselName;
			const url = `${commonUtils.getLogsPdfBaseUrl()}/upload_pdf?code=${code}&selectedDate=${selectedDate}&tenantName=${tenantName}&tenantId=${tenantId}&vesselId=${vesselId}&isIDL=${isIDL}&vesselName=${vesselName}`;
			const response = await fetch(url, {
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (response.ok) {
				toast.success("Job regenerated successfully");
			} else {
				throw new Error("Failed to regenerate job");
			}
		} catch (err) {
			console.log(err);
			toast.error("Failed to regenerate job");
		} finally {
			loadJobsHistory(currentPage); // Refresh jobs list after regeneration
			// Remove this job from regenerating set
			setRegeneratingJobs((prev) => {
				const newSet = new Set(prev);
				newSet.delete(job.raw);
				return newSet;
			});
		}
	};

	const toggleExpandedRow = (jobId: string) => {
		setExpandedRows((prev) =>
			prev.includes(jobId)
				? prev.filter((id) => id !== jobId)
				: [...prev, jobId]
		);
	};

	const handleSort = (field: string) => {
		if (sortBy === field) {
			setSortDirection(sortDirection === "asc" ? "desc" : "asc");
		} else {
			setSortBy(field);
			setSortDirection("asc");
		}
	};

	const handleDateRange = (range: RangeKeyDict) => {
		const { selection } = range;
		setDateRange([selection]);
	};

	const handleFilterChange = (key: string, value: any) => {
		setFilters((prevFilters) => ({
			...prevFilters,
			[key]: value,
		}));
	};

	const getJobs = () => {
		if (!props.jobsHistory.jobs) return [];

		// Use fresh data from API (already filtered by backend)
		let jobs = props.jobsHistory.jobs;

		// Apply sorting only (filtering is handled by backend)
		jobs.sort((a: IJobData, b: IJobData) => {
			let valueA, valueB;

			switch (sortBy) {
				case "timestamp":
					valueA = new Date(a.timestamp).getTime();
					valueB = new Date(b.timestamp).getTime();
					break;
				case "date":
					valueA = new Date(a.date).getTime();
					valueB = new Date(b.date).getTime();
					break;
				case "vesselName":
					valueA = (a.vesselName || "").toLowerCase().trim();
					valueB = (b.vesselName || "").toLowerCase().trim();
					break;
				case "tenant":
					valueA = (a.tenantName || "").toLowerCase().trim();
					valueB = (b.tenantName || "").toLowerCase().trim();
					break;
				case "code":
					valueA = (a.code || "").toLowerCase().trim();
					valueB = (b.code || "").toLowerCase().trim();
					break;
				default:
					valueA = new Date(a.timestamp).getTime();
					valueB = new Date(b.timestamp).getTime();
			}

			// Handle different types of comparison
			if (sortBy === "timestamp" || sortBy === "date" || sortBy === "default") {
				// Numeric comparison for timestamps and dates
				const numA = valueA as number;
				const numB = valueB as number;
				if (sortDirection === "asc") {
					return numA > numB ? 1 : -1;
				} else {
					return numA < numB ? 1 : -1;
				}
			} else {
				// String comparison for text fields
				const strA = valueA as string;
				const strB = valueB as string;
				const comparison = strA.localeCompare(strB);
				return sortDirection === "asc" ? comparison : -comparison;
			}
		});

		return jobs;
	};

	const renderJobsTable = (jobs: IJobData[]) => {
		const renderSortIcon = (field: string) => {
			if (sortBy !== field) return null;
			return sortDirection === "asc" ? "↑" : "↓";
		};

		return (
			<div>
				<InfiniteProgress
					isLoading={props.jobToRefreshLogsPdfJobHistory?.isLoading}
					isSpacedOut={false}
				/>
				<table
					className={classNames(
						"w-full relative border border-gray-300 rounded-sm bp3-html-table bp3-interactive",
						{
							"animate-pulse":
								isLoading || props.jobToRefreshLogsPdfJobHistory?.isLoading,
						}
					)}
				>
					<thead className="relative">
						<tr>
							<th className="text-sm text-gray-500">No.</th>
							<th
								className="text-sm text-gray-500 cursor-pointer"
								onClick={() => handleSort("tenant")}
							>
								Tenant Name {renderSortIcon("tenant")}
							</th>
							<th
								className="text-sm text-gray-500 cursor-pointer"
								onClick={() => handleSort("vesselName")}
							>
								Vessel Name {renderSortIcon("vesselName")}
							</th>
							<th
								className="text-sm text-gray-500 cursor-pointer"
								onClick={() => handleSort("code")}
							>
								Log Type {renderSortIcon("code")}
							</th>
							<th
								className="text-sm text-gray-500 cursor-pointer"
								onClick={() => handleSort("date")}
							>
								Date {renderSortIcon("date")}
							</th>
							<th className="text-sm text-center text-gray-500">Status</th>
							<th className="text-sm text-center text-gray-500">Actions</th>
						</tr>
					</thead>
					<tbody
						className={classNames({
							"h-0 opacity-0 transition-all duration-100 max-h-0":
								isLoading || props.jobToRefreshLogsPdfJobHistory?.isLoading,
							"h-auto opacity-100 transition-all duration-1000 delay-300 max-h-auto":
								!isLoading && !props.jobToRefreshLogsPdfJobHistory?.isLoading,
						})}
					>
						{!isLoading && !props.jobToRefreshLogsPdfJobHistory?.isLoading && (
							<>
								{jobs.length === 0 ? (
									<tr>
										<td colSpan={7} className="text-center py-12">
											<div className="flex flex-col items-center justify-center text-gray-500">
												<svg
													className="w-16 h-16 mb-4 text-gray-300"
													fill="none"
													stroke="currentColor"
													viewBox="0 0 24 24"
												>
													<path
														strokeLinecap="round"
														strokeLinejoin="round"
														strokeWidth={1.5}
														d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
													/>
												</svg>
												<h3 className="text-xl font-medium text-gray-900 mb-2">
													No Jobs Found
												</h3>
												<p className="text-sm text-gray-500 max-w-md text-center">
													No PDF generation jobs were found for the selected
													criteria. Jobs will appear here once they are
													processed.
												</p>
											</div>
										</td>
									</tr>
								) : (
									jobs.map((job, index) => {
										// Check if this specific job is regenerating
										const isJobRegenerating = regeneratingJobs.has(job.raw);

										return (
											<React.Fragment key={`${job.raw}-${index}`}>
												<tr
													className={classNames(
														"hover:bg-gray-50 transition-colors duration-150 w-full cursor-pointer",
														job.isFailure ? "bg-red-50" : "bg-green-50"
													)}
													onClick={() =>
														toggleExpandedRow(`${job.raw}-${index}`)
													}
												>
													<td>
														<div className="text-sm font-medium text-gray-900">
															{(currentPage - 1) * 10 + (index + 1)}
														</div>
													</td>
													<td>
														<div className="text-sm font-medium text-gray-900">
															{job.tenantName}
														</div>
													</td>
													<td>
														<div className="text-sm font-medium text-gray-900">
															{job.vesselName}
														</div>
													</td>
													<td>
														<div className="text-sm font-medium text-gray-900">
															{job.code}
														</div>
													</td>
													<td>
														<div className="text-sm font-medium text-gray-900">
															{job.date}
														</div>
													</td>
													<td className="text-center">
														<div className="text-sm font-medium">
															<span
																className={classNames(
																	"px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full",
																	job.isFailure
																		? "bg-red-100 text-red-800"
																		: "bg-green-100 text-green-800"
																)}
															>
																{job.status ? job.status.split("_").join(" ") :
																	(job.isFailure ? "Failed" : "Success")}
															</span>
														</div>
													</td>
													<td className="text-center">
														<div className="text-sm font-medium flex gap-2 justify-center">
															<button
																className={classNames(
																	"px-3 py-1 rounded-sm text-xs border transition-colors focus:outline-none inline-flex items-center gap-2",
																	isJobRegenerating
																		? "bg-blue-100 text-blue-800 border-blue-300 cursor-wait"
																		: "bg-blue-50 hover:bg-blue-100 text-blue-700 border-blue-200"
																)}
																onClick={(e) => {
																	e.stopPropagation(); // Prevent row expansion
																	handleRegenerate(job);
																}}
																disabled={isJobRegenerating}
															>
																{isJobRegenerating ? (
																	<>
																		<div className="w-3 h-3 border-2 border-blue-300 border-t-blue-600 rounded-full animate-spin"></div>
																		<span>Regenerating...</span>
																	</>
																) : (
																	"Regenerate"
																)}
															</button>
														</div>
													</td>
												</tr>
												{expandedRows.includes(`${job.raw}-${index}`) && (
													<tr className="bg-gray-50">
														<td
															colSpan={7}
															className="px-6 py-4 text-sm text-gray-600"
														>
															<div className="space-y-2">
																<p>
																	<strong>Message:</strong>{" "}
																	{job.message || "No message"}
																</p>
																<p>
																	<strong>Year/Month/Date:</strong> {job.year}/
																	{job.month}/{job.date}
																</p>
																<p>
																	<strong>International Date Line:</strong>{" "}
																	{job.internationalDateLine}
																</p>
																<p>
																	<strong>Storage Key:</strong> {job.storageKey}
																</p>
																<p>
																	<strong>Raw:</strong> {job.raw}
																</p>
																<p>
																	<strong>Last Processed:</strong>{" "}
																	{new Date(job.timestamp).toLocaleString()}
																</p>
															</div>
														</td>
													</tr>
												)}
											</React.Fragment>
										);
									})
								)}
							</>
						)}
					</tbody>
				</table>
			</div>
		);
	};

	// Filter section removed as requested

	const getStats = () => {
		// Use stats from API response (already filtered by backend)
		return (
			props.jobsHistory.stats || {
				total: 0,
				success: 0,
				failures: 0,
			}
		);
	};

	const renderStats = () => {
		const stats = getStats();
		const isLoadingStats =
			isLoading || props.jobToRefreshLogsPdfJobHistory?.isLoading;
		const hasNoData =
			!props.jobsHistory?.jobs || props.jobsHistory.jobs.length === 0;

		return (
			<div className="flex flex-row gap-4 mb-4">
				<div
					className={classNames(
						"bg-white p-4 rounded-lg border cursor-pointer flex-1",
						filters.status === "all" ? "border-blue-500" : "border-gray-200"
					)}
					onClick={() => handleFilterChange("status", "all")}
				>
					<div className="text-gray-500 text-sm">Total Jobs</div>
					<div className="text-2xl font-bold">
						{isLoadingStats ? (
							<div className="w-8 h-6 bg-gray-200 rounded animate-pulse"></div>
						) : 
							stats.total
						}
					</div>
				</div>
				<div
					className={classNames(
						"bg-white p-4 rounded-lg border cursor-pointer flex-1",
						filters.status === "success"
							? "border-green-500"
							: "border-gray-200"
					)}
					onClick={() => handleFilterChange("status", "success")}
				>
					<div className="text-green-500 text-sm">Success</div>
					<div className="text-2xl font-bold">
						{isLoadingStats ? (
							<div className="w-8 h-6 bg-gray-200 rounded animate-pulse"></div>
						) : 
							stats.success
						}
					</div>
				</div>
				<div
					className={classNames(
						"bg-white p-4 rounded-lg border cursor-pointer flex-1",
						filters.status === "failure" ? "border-red-500" : "border-gray-200"
					)}
					onClick={() => handleFilterChange("status", "failure")}
				>
					<div className="text-red-500 text-sm">Failures</div>
					<div className="text-2xl font-bold">
						{isLoadingStats ? (
							<div className="w-8 h-6 bg-gray-200 rounded animate-pulse"></div>
						) :
							stats.failures
						}
					</div>
				</div>
			</div>
		);
	};

	return (
		<div className="bg-white flex flex-col gap-6">
			<Toaster
				position="top-right"
				toastOptions={{
					duration: 3000,
					style: {
						background: "#333",
						color: "#fff",
					},
				}}
			/>

			{/* Filter Section */}
			<div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
				<div className="flex justify-between items-center mb-4">
					<h3 className="text-lg font-medium text-gray-900">Filters</h3>
					<button
						type="button"
						onClick={handleClearFilters}
						disabled={isLoading}
						className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
					>
						Clear Filters
					</button>
				</div>
				<div className="flex flex-wrap gap-4 items-end">
					<div className="w-64">
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Tenant
						</label>
						<Select
							id="tenants"
							isClearable
							isSearchable
							isDisabled={isLoading}
							placeholder={"Search tenants"}
							unstyled
							value={selectedTenantOption}
							options={tenantOptions}
							onChange={(newValue) => {
								setSelectedTenantOption(newValue);
								setSelectedVesselOption(null); // Reset vessel when tenant changes
							}}
							className={classNames("text-sm")}
							menuPosition="fixed"
							classNames={{
								option: ({ isFocused, isSelected }) =>
									clsx(
										isFocused && optionStyles.focus,
										isSelected && optionStyles.selected,
										optionStyles.base
									),
								dropdownIndicator: () => dropdownIndicatorStyles,
								menu: () => menuStyles,
								clearIndicator: () => clearIndicatorStyles,
								placeholder: () => placeholderStyles,
								control: ({ isFocused, isDisabled }) =>
									clsx(
										isFocused ? controlStyles.focus : controlStyles.nonFocus,
										isDisabled ? controlStyles.disabled : controlStyles.base
									),
								valueContainer: ({ isDisabled }) =>
									clsx("pl-1", isDisabled && "bg-gray-200 ml-2"),
							}}
						/>
					</div>

					<div className="w-64">
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Vessel
						</label>
						<Select
							id="vessels"
							isClearable
							isSearchable
							isDisabled={isLoading || !selectedTenantOption}
							placeholder={"Search vessels"}
							unstyled
							value={selectedVesselOption}
							options={vesselOptions}
							onChange={(newValue) => {
								setSelectedVesselOption(newValue);
							}}
							className={classNames("text-sm")}
							menuPosition="fixed"
							classNames={{
								option: ({ isFocused, isSelected }) =>
									clsx(
										isFocused && optionStyles.focus,
										isSelected && optionStyles.selected,
										optionStyles.base
									),
								dropdownIndicator: () => dropdownIndicatorStyles,
								menu: () => menuStyles,
								clearIndicator: () => clearIndicatorStyles,
								placeholder: () => placeholderStyles,
								control: ({ isFocused, isDisabled }) =>
									clsx(
										isFocused ? controlStyles.focus : controlStyles.nonFocus,
										isDisabled ? controlStyles.disabled : controlStyles.base
									),
								valueContainer: ({ isDisabled }) =>
									clsx("pl-1", isDisabled && "bg-gray-200 ml-2"),
							}}
						/>
					</div>

					<div className="w-64">
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Log Type
						</label>
						<Select
							id="log-type"
							isClearable
							isSearchable
							isDisabled={isLoading}
							placeholder={"Select log"}
							unstyled
							value={selectedLogOption}
							options={logTypeOptions}
							onChange={(newValue) => {
								setSelectedLogOption(newValue);
							}}
							className={classNames("text-sm")}
							menuPosition="fixed"
							classNames={{
								option: ({ isFocused, isSelected }) =>
									clsx(
										isFocused && optionStyles.focus,
										isSelected && optionStyles.selected,
										optionStyles.base
									),
								dropdownIndicator: () => dropdownIndicatorStyles,
								menu: () => menuStyles,
								clearIndicator: () => clearIndicatorStyles,
								placeholder: () => placeholderStyles,
								control: ({ isFocused, isDisabled }) =>
									clsx(
										isFocused ? controlStyles.focus : controlStyles.nonFocus,
										isDisabled ? controlStyles.disabled : controlStyles.base
									),
								valueContainer: ({ isDisabled }) =>
									clsx("pl-1", isDisabled && "bg-gray-200 ml-2"),
							}}
						/>
					</div>

					<div className="w-64">
						<label className="block text-sm font-medium text-gray-700 mb-1">
							Date Range
						</label>
						<DateRangePickerVerbose
							handleOnChange={handleDateRange}
							onClose={() => setIsDatePickerOpen(false)}
							handleOpen={() => setIsDatePickerOpen(true)}
							isOpen={isDatePickerOpen}
							dateRange={dateRange}
							staticRanges={logsPdfDefaultStaticRanges}
							disabled={isLoading}
						/>
					</div>

					{/* Bulk Regenerate Button */}
					{/* <div className="w-auto">
						<label className="block text-sm font-medium text-gray-700 mb-1">
							&nbsp;
						</label>
						<button
							className="inline-flex items-center gap-2 px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
							onClick={handleBulkRegenerate}
							disabled={isLoading || isRefreshing}
						>
							{isRefreshing ? <>Regenerating...</> : <>Bulk Regenerate</>}
						</button>
					</div> */}
				</div>
			</div>

			<div className="overflow-y-auto flex flex-col gap-2">
				{renderStats()}

				{renderJobsTable(getJobs())}

				{/* Pagination */}
				{getPaginationForView().totalItems > 0 && (
					<Pagination
						{...getPaginationForView()}
						onPageChange={handlePageChange}
						isPageLoading={
							isLoading || props.jobToRefreshLogsPdfJobHistory?.isLoading
						}
					/>
				)}
			</div>

			{/* Bulk Regenerate Confirmation Modal */}
			{/* {renderBulkRegenerateModal()} */}
		</div>
	);
}

function mapStateToProps(store: IStore) {
	const toolStore = (store as any).app.tool;
	const authStore = store.app.auth;
	return {
		jobsHistory: toolStore?.jobsHistory || {
			jobs: [],
			stats: { total: 0, success: 0, failures: 0, byTenant: {} },
			pagination: {
				total: 0,
				offset: 0,
				limit: 10,
				hasMore: false,
				returned: 0,
			},
		},
		jobsHistoryPagination: toolSelectors.getJobsHistoryPagination(toolStore),
		user: authStore?.user || null,
		jobToRefreshLogsPdfJobHistory:
			toolSelectors.jobToRefreshLogsPdfJobHistory(toolStore),
		vessels: toolStore?.vessels || { byIds: {}, ids: [] },
		tenants: toolStore?.tenants || { byIds: {}, ids: [] },
	};
}

function mapDispatchToProps(dispatch: Dispatch) {
	return {
		loadJobsHistory: (page?: number, limit?: number, filters?: any) => {
			return new Promise((resolve, reject) => {
				try {
					dispatch(
						toolActions.commands.toolJobsHistoryLoad(page, limit, filters)
					);
					resolve(true);
				} catch (error) {
					reject(error);
				}
			});
		},
		loadTenants() {
			dispatch(toolActions.commands.toolTenantListLoad());
		},
		loadVessels(tenantId: string) {
			dispatch(toolActions.commands.toolTenantSpecificVesselLoad(tenantId));
		},
	};
}

const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector> & {
	vessels?: {
		byIds: { [vesselId: string]: IVessel };
		ids: string[];
	};
};
export default reduxConnector(JobsHistory);
